/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bookingTokenStatusSchema = z.enum(['pending', 'booked', 'cancelled', 'expired', 'invalidated'])

export type BookingTokenStatusSchema = z.infer<typeof bookingTokenStatusSchema>
